import { render } from "./SelectInput.vue?vue&type=template&id=429a7e70"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhost/KIRON/app/datos.kiron.es/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__